import { H3 } from "@blueprintjs/core";
import * as React from "react";
import FileUploader from "react-firebase-file-uploader";
import firebase from "../firebase";
import { firestore } from "../firebase";
import "../styles/logo.css";

interface IBusinessLogoUploaderProps {
  businessId: string;
}

interface IBusinessLogoUploaderState {
  logo: string;
}

export default class BusinessLogoUploader extends React.Component<
  IBusinessLogoUploaderProps,
  IBusinessLogoUploaderState
> {
  public state: IBusinessLogoUploaderState = {
    logo: ""
  };
  public componentDidMount = async () => {
    const { businessId } = this.props;
    const businessQuery = await firestore
      .collection("businesses")
      .doc(businessId)
      .get();
    const data = businessQuery.data();
    if (data) {
      this.setState({ logo: data.theme.logo });
    }
  };

  public componentWillReceiveProps = async (props: any) => {
    if (props.businessId !== this.props.businessId) {
      const businessQuery = await firestore
        .collection("businesses")
        .doc(props.businessId)
        .get();
      const data = businessQuery.data();
      if (data) {
        this.setState({ logo: data.theme.logo });
      }
    }
  };
  public render() {
    return (
      <div>
        <H3>Business Logo</H3>
        <FileUploader
          accept="image/*"
          name="avatar"
          randomizeFilename={false}
          storageRef={firebase.storage().ref("uploaded-logos")}
          onUploadStart={this.handleUploadStart}
          onUploadError={this.handleUploadError}
          onUploadSuccess={this.handleUploadSuccess}
          onProgress={this.handleProgress}
        />
        <br />
        <img className={"logo"} src={this.state.logo} />
      </div>
    );
  }

  private handleUploadStart = () => {
    console.log("starting upload..");
  };

  private handleUploadError = error => {
    console.log("Error");
  };

  private handleUploadSuccess = filename => {
    const { businessId } = this.props;
    console.log("Success");
    firebase
      .storage()
      .ref("uploaded-logos")
      .child(filename)
      .getDownloadURL()
      .then(async url => {
        this.setState({ logo: url });
        const business = await firestore
          .collection("businesses")
          .doc(businessId)
          .get();
        business.ref.update({ "theme.logo": url });
      });
  };

  private handleProgress = progress => {
    console.log(progress);
  };
}



// WEBPACK FOOTER //
// ./src/components/BusinessLogoUploader.tsx